// extracted by mini-css-extract-plugin
export default {"container":"titleComponent_container__pU-79"};